<template>
  <q-dialog
    v-bind="$attrs"
    v-on="$listeners"
  >
    <q-card style="min-width: 90vw">
      <q-form @submit="$emit('submit')">
        <q-card-section
          class="q-gutter-sm scroll"
          style="max-height: 80vh"
        >
          <div class="text-h6">
            Constatation
          </div>
          <q-input
            v-model="constatation.content"
            type="textarea"
            filled
            label="Commentaire"
          />
          <div class="text-center">
            <q-field
              :value="constatation.file"
              borderless
              dense
              color="primary-app"
              class="inline"
            >
              <btn-camera v-model="constatation.file" />
            </q-field>
          </div>
          <lwf-photo :picture="constatation.file">
            <q-btn
              round
              icon="fa fa-times"
              color="primary"
              size="xs"
              class="float-right q-ma-sm"
              @click="$delete(constatation, 'file')"
            />
          </lwf-photo>
        </q-card-section>
        <q-card-actions align="right">
          <q-btn
            v-close-popup
            label="Annuler"
            flat
          />
          <q-btn
            label="Enregistrer"
            flat
            type="submit"
          />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>
<script>
import BtnCamera from 'components/core/BtnCamera'
import LwfPhoto from 'components/core/LwfPhoto'

export default {
  name: 'DialogEventMessage',
  components: { BtnCamera, LwfPhoto },
  props: {
    constatation: {
      type: Object,
      default: _.stubObject
    }
  }
}
</script>
